import styled from 'styled-components';

import { BorderRadius } from '../../../tokens/borderRadius';
import { COLORS } from '../../../tokens/colors';
import { FONTS } from '../../../tokens/fonts';

type IStyleProps = {
    isChecked: boolean | undefined,
    disabled: boolean,
    withLabel: boolean,
}

export const Label = styled.label<IStyleProps>`
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    display: inline-block;
    margin: 0 5px 0 0;
    user-select: none;
    position: relative;

    span {
        display: inline-block;
        white-space: nowrap;
        cursor: pointer;
        padding: 10px 24px;
        transition: background 0.2s ease;
        ${FONTS.MediumXS};
        border-radius: ${BorderRadius.OuterBlockRadius};
        color: ${COLORS.TextHint};
    }

    input[type="checkbox"] {
        z-index: -1;
        opacity: 0;
        display: block;
        width: 0;
        height: 0;

        position: relative;
        appearance: none;
        flex: 0 0 auto;
        margin: 0;
        border-radius: 50%;
        transition: .3s;
        outline: none;
        box-sizing: border-box;
        cursor: pointer;

        & + span {
        background-color: ${COLORS.BgSurface};

          @media (hover: hover) {
              &:hover {
                  background-color: ${COLORS.BgSecondary};
              }
            }
        }

        &:checked + span {
            background-color: ${COLORS.ButtonPrimary};
            color: ${COLORS.TextWhite};
        }
    }
`;
